import { configureStore } from '@reduxjs/toolkit'
import usersSlice from './slices/usersSlice';
import userSlice from './slices/userSlice';

import authSlice from './slices/authSlice';
import educationSlice from './slices/educationSlice';
import exerciseSlice from './slices/exerciseSlice';
import instructionSlice from './slices/instructionSlice';
import questionnaireSlice from './slices/questionnaireSlice';
import todaysTaskSlice from './slices/todaysTaskSlice'
import performanceSlice from './slices/performanceSlice';

const store = configureStore({
  reducer: {
    users: usersSlice,
    user: userSlice,
    auth: authSlice,
    education: educationSlice,
    exercise: exerciseSlice,
    instruction: instructionSlice,
    todaysTasks: todaysTaskSlice,
    performance:performanceSlice,
    questionnaire:questionnaireSlice
  },
})

export default store;